import useSingleTrackingEvent from "@Events/hooks/useSingleTrackingEvent";
import SubmitBusRentFormModel from "@Events/models/SubmitBusRentFormModel";

export default function useSubmitBusRentFormEvent(email: string) {
    return useSingleTrackingEvent("submit_bus_rent_form", SubmitBusRentFormModel(email))
}